import { render, staticRenderFns } from "./NoDevice.vue?vue&type=template&id=56dde51f&"
import script from "./NoDevice.vue?vue&type=script&lang=js&"
export * from "./NoDevice.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports